/**
 * Created by minimus on 10.07.2015.
 */
(function () {
  const adList = samProOptions.adList;
  const dlgStrings = samProOptions.strings;
  tinymce.PluginManager.requireLangPack('spButton');

  tinymce.create('tinymce.plugins.spButton', {
    init: function (ed, url) {
      this.editor = ed;
      const title = dlgStrings.title;

      ed.addCommand('samProObj', () => {
        ed.windowManager.open({
          title: dlgStrings.title,
          width: 450,
          height: 280,
          inline: 1,
          body: [
            {
              type: 'listbox',
              name: 'ad_object',
              label: dlgStrings.selector,
              values: adList
            },
            {
              type   : 'checkbox',
              name   : 'sam_codes',
              label  : 'Tags',
              text   : dlgStrings.hint,
              checked : true
            }
          ],
          buttons: [
            {text: dlgStrings.insert, onclick: 'submit'},
            {text: dlgStrings.cancel, onclick: 'close'}
          ],
          onsubmit: function (e) {
            ed.insertContent(`[sam_pro id=${e.data.ad_object} codes="${(e.data.sam_codes) ? 'true' : 'false'}"]`);
          }
        });
      });

      ed.addButton('spButton', {title: title, cmd: 'samProObj', image: url + '/img/sam-icon.png'});
    },

    getInfo: function () {
      return {
        longname: 'SAM Pro',
        author: 'minimus',
        authorurl: 'http://blogcoding.ru/',
        infourl: 'http://uncle-sam.info/',
        version: "1.0.0.10"
      };
    }
  });

  tinymce.PluginManager.add('spButton', tinymce.plugins.spButton);
})();